import { render } from "./TaskView2.vue?vue&type=template&id=5f80233c&scoped=true"
import script from "./TaskView2.vue?vue&type=script&lang=js"
export * from "./TaskView2.vue?vue&type=script&lang=js"

import "./TaskView2.vue?vue&type=style&index=0&id=5f80233c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f80233c"]])

export default __exports__